import { Video } from '../common/video';

export const VideoSlice = ({
  primary: { youtube_url: video, thumbnail },
  className = '',
}) => {

  return (
    <div className={className + ' max-w-[800px] mx-auto md:px-6 video-slice'}>
      <Video video={video} image={thumbnail} />
    </div>
  );
};
